import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';


import { HttpClient } from '@angular/common/http';

import { anyU } from 'src/app/models/anyU';
import { environment } from 'src/environments/environment';
import { todoU } from 'src/app/models/todoU';
declare var bootstrap: any;


@Component({
  selector: 'app-todo',
  templateUrl: './todo.component.html',
  styleUrls: ['./todo.component.css']
})
export class TodoComponent {

  baseUrl = environment.apiBaseUrl;
  @ViewChild('userModal') userModal: ElementRef | undefined;

//u3
  @ViewChild('detailModal') detailModal!: ElementRef;
  detailObj: any = null;
  searchText: string = '';
  filteredList: any[] = [];

  anyList: any[] = [];
  anyObj: any ={
      "id":0,
      "title":"",
      "description":"",
      "wich_kind":"",

  }
  http = inject(HttpClient);

   ngOnInit(): void {
  this.getAlltodo()
  }

  // constructor(private userService: Service) {}

  openModal(): void {
  // console.log("openModal triggered");
  if (this.userModal) {
    const modal = new bootstrap.Modal(this.userModal.nativeElement);
    modal.show();
  } else {
    // console.warn("userModal is undefined!");
  }
}

//u3
openDetailModal(item: any): void {
  this.detailObj = item;

  const modal = new bootstrap.Modal(this.detailModal.nativeElement);
  modal.show();
}

closeModal(): void {
  if (this.userModal) {
    const modal = bootstrap.Modal.getInstance(this.userModal.nativeElement);
    if (modal) modal.hide();
  }
}

  getAlltodo(): void {

    this.http.get<todoU[]>(`${this.baseUrl}/todo`).subscribe((res) => {
      this.anyList = res;
       //u3
      this.filteredList = res;
      // console.log(this.anyList); // چاپ داده‌ها برای بررسی
    });
  }

   onSearch(): void {
    const text = this.searchText.toLowerCase().trim();
    this.filteredList = this.anyList.filter(item =>
      item.title.toLowerCase().includes(text) ||
      item.description.toLowerCase().includes(text)

    );
  }

  onSave(): void {
  if (this.anyObj.id === 0) {
    // افزودن
    const newUser = { ...this.anyObj };
    delete newUser.id; // ← ID را حذف کن که نره به سرور

    this.http.post<todoU>(`${this.baseUrl}/todo`, newUser).subscribe((res) => {
      this.getAlltodo();
      this.closeModal();
    });
  } else {
    // ویرایش
    // this.http.put<anyU>(`${this.baseUrl}/mythings/${this.anyObj.id}`, this.anyObj).subscribe((res) => {

    this.http.post<todoU>(`${this.baseUrl}/todo/update`, this.anyObj).subscribe((res) => {
      this.getAlltodo();
      this.closeModal();
    });
  }
}


  // باز کردن مدال برای ویرایش
  openEditModal(user: any): void {
    this.anyObj = { ...user }; // پر کردن فیلدها با داده‌های کاربر انتخاب‌شده
    this.openModal();
  }

  // حذف کاربر
  delete(Id: number): void {
    if (confirm("آیا مطمئن هستید که می‌خواهید این کاربر را حذف کنید؟")) {
      // this.http.delete(`${this.baseUrl}/mythings/${Id}`).subscribe(() => {
        // this.http.post(`${this.baseUrl}/mythings/delete`, Id).subscribe(() => {
        this.http.post(`${this.baseUrl}/todo/delete/${Id}`, null).subscribe(() => {

        this.getAlltodo(); // بعد از حذف، لیست کاربران را مجدد بگیر
      });
    }
  }

  fixUrl(url: string): string {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return 'http://' + url;
}


}


